import { render, staticRenderFns } from "./FacebookRawData.vue?vue&type=template&id=13e54c7f&"
import script from "./FacebookRawData.vue?vue&type=script&lang=js&"
export * from "./FacebookRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports